<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top" @click="onAdd()">
        <div class="flex-1 font-16-30313a">公告分类</div>
        <div class="tip-20-bg-30313a">
          <i class="el-icon-plus font-bold"></i>
        </div>
      </div>
      <div class="flex-1 h-0" v-if="classifyList && classifyList.length > 0">
        <cate-menu :menu-data="classifyList" :not-add="true" :not-delete="true" :not-edit="true" @on-choose="onChooseMenu"
          :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0">
      <div style="padding: 10px 20px 20px 0" class="flex-column h-100">
        <div class="flex content-top mt-10">
          <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
            <div class="tab-item " :class="index === statusIndex ? 'active' : ''" v-for="(item, index) in noticeStatus"
              :key="index" @click="changceStatus(item, index)">
              <span :class="index === statusIndex ? 'bg-4-46b8b0' : 'bg-4-e2'"></span>
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="flex ptb-10" v-if="statusIndex === 0 && permission.includes('addAnnouncement')">
          <div class="btn-24-bg-ff flex align-center mr-5" @click="addNotice()">
            <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
            新增公告
          </div>
        </div>
        <div class="flex-1 flex-column h-0" style="overflow-y: auto;">
          <div class="bg-ff border-ra mb-20 flex" v-for="(item, index) in noticeList" :key="index">
            <div class="flex-1 p-15">
              <div class="flex align-center">
                <div class="font-14-30313a">{{ item.name }}</div>
                <div class="flex-1 flex justify-end">
                  <button class="btn-16-bg-85" v-if="item.status === 1 && permission.includes('downAnnouncement')"
                    @click="shelves(item.id, -1)">下架</button>
                  <button class="btn-16-bd-85 mr-5" v-if="item.status === -1 && permission.includes('upAnnouncement')"
                    @click="shelves(item.id, 1)">上架</button>
                  <button class="btn-16-bd-ff5555" v-if="item.status === -1 && permission.includes('deleteAnnouncement')"
                    @click="deleteNotice(item.id)">删除</button>
                </div>
              </div>
              <div class="font-12-b9b9b9 text-left">{{ Utils.formatTime2(item.createTime) }}</div>
              <div class="pt-10 font-12-424142 text-left">{{ item.content }}</div>
            </div>
            <div class="plr-40 flex-column align-center justify-center" style="border-left: 1px dashed #e2e2e2;">
              <div class="enclosure-item flex-column align-center">
                <img :src="item.file ? getEnclosureTypeImg(item.file) : '/static/images/addFile.png'" class="type-img"
                  alt="" @click="dowloadFile(item)">
                <div class="mt-10" :class="item.file ? 'btn-16-bd-46b8b0' : 'btn-16-bg-46b8b0'"
                  v-if="permission.includes('uploadAnnouncement')">
                  <el-upload name="modifyfile" :data="item" :limt="1" :httpRequest="httpRequestImg" :action="upload"
                    :show-file-list="false">
                    <div>{{ item.file ? '重新上传' : '上传文件' }}</div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump">
        </Pagination>
      </div>
    </div>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="400px" title="新增公告分类"
      :visible.sync="isNoticeClassify" @closed="onCloseNotice">
      <div class="p-20">
        <div class="flex align-center">
          <div class="font-12-30313a mr-5">公告分类名称：</div>
          <el-input v-model="noticeName" class="flex-1" placeholder="请输入公告分类名称"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseNotice">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="submitNotice">确定</div>
      </div>
    </el-dialog>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="526px" title="新增公告"
      :visible.sync="isNoticeShow" @closed="onClose">
      <div class="p-20">
        <div class="flex align-center">
          <el-input v-model="notice.name" class="flex-1" placeholder="请输入公告标题"></el-input>
        </div>
        <div class="flex align-center pt-20">
          <el-input v-model="notice.content" type="textarea" class="flex-1" placeholder="请输入公告内容"></el-input>
        </div>
        <div class="ptb-20 enclosure-container">
          <div class="flex">
            <div class="flex align-center mr-5 mb-5 btn-24-bd-30313a">
              <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
              <el-upload name="file" data="" :httpRequest="httpRequestImg" :action="upload" :show-file-list="false">
                <div>上传文件</div>
              </el-upload>
            </div>
          </div>
          <div class="enclosure-item" v-if="fileList">
            <a target="_blank"><img :src="getEnclosureTypeImg(fileList)" class="type-img" alt=""></a>
            <i class="el-icon-error" @click="removeEnclosure()"></i>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onClose">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="submit">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import CateMenu from '@/components/CateMenu'
import MoveHorizon from '@/components/MoveHorizon'
import Pagination from '@/components/Pagination'
export default {
  name: 'announcement',
  components: { CateMenu, MoveHorizon, Pagination },
  data () {
    return {
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`,
      page: 1,
      limit: 25,
      pageSize: 0, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 0, // 总条数
      classifyList: [],
      chooseMenuId: 0,
      statusIndex: 0,
      currentClassify: {},
      isNoticeShow: false,
      isNoticeClassify: false,
      noticeName: '',
      noticeStatus: [
        {
          name: '已发布',
          status: 1
        },
        {
          name: '已下架',
          status: -1
        }
      ],
      currentStatus: {},
      noticeList: [],
      notice: {
        name: '',
        content: ''
      },
      fileList: '',
      permission: ''
    }
  },
  created () {
    this.getPermission()
    this.getClassify(true)
    this.currentStatus = this.noticeStatus[0]
  },
  mounted () { },
  methods: {
    dowloadFile (item) {
      let x = new XMLHttpRequest()
      x.open('GET', 'https://jhj-erp.oss-cn-beijing.aliyuncs.com' + item.file, true)
      x.responseType = 'blob'
      x.onload = function () {
        let url = window.URL.createObjectURL(x.response)
        let a = document.createElement('a')
        a.href = url
        a.download = item.name
        a.click()
      }
      x.send()
    },
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'announcement',
        parentGroup: 'announcement'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    getClassify (isRefresh) {
      this.classifyList = []
      this.axios.post('noticeClassify/list', { companyId: this.$store.state.companyId }).then(res => {
        if (res.data.success) {
          this.classifyList = res.data.data
          if (isRefresh) {
            if (this.classifyList.length > 0) {
              this.currentClassify = this.classifyList[0]
              this.chooseMenuId = this.classifyList[0].id
              this.getDetail()
            }
          }
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg,
            offset: 400
          })
        }
      })
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseMenuId) {
        this.currentClassify = menu
        this.chooseMenuId = menu.id
        this.getDetail()
      }
    },
    changceStatus (currentStatus, index) {
      this.currentStatus = currentStatus
      this.statusIndex = index
      this.getDetail()
    },
    getDetail () {
      this.loading = true
      let param = {
        page: this.page,
        limit: this.limit,
        classifyId: this.currentClassify.id,
        companyId: this.$store.state.companyId,
        status: this.currentStatus.status
      }
      this.axios.post('notice/queryForPage', param).then(res => {
        if (res.data.success) {
          this.noticeList = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    shelves (id, status) {
      let params = {
        id: id,
        status: status
      }
      this.axios.post('notice/modify', params).then(res => {
        if (res.data.success) {
          let tip = ''
          if (status === 1) {
            tip = '上架成功'
          } else {
            tip = '下架成功'
          }
          this.$message.success(tip)
          this.getDetail()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    deleteNotice (id) {
      let params = {
        id: id
      }
      this.axios.post('notice/deleteById', this.qs.stringify(params)).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getDetail()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    modifyNotice (id, file) {
      let params = {
        id: id,
        file: file
      }
      this.axios.post('notice/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.fileList = ''
          this.getDetail()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    addNotice () {
      this.isNoticeShow = true
    },
    onClose () {
      this.isNoticeShow = false
      this.notice.name = ''
      this.notice.content = ''
      this.fileList = ''
    },
    submit () {
      if (!this.notice.name) {
        this.$message.warning('请输入公告名称')
      } else if (!this.notice.content) {
        this.$message.warning('请输入公告内容')
      } else {
        let params = {
          name: this.notice.name,
          content: this.notice.content,
          classifyId: this.currentClassify.id,
          companyId: this.$store.state.companyId,
          file: this.fileList
        }
        this.axios.post('notice/save', params).then(res => {
          if (res.data.success) {
            this.$message.success('添加公告成功,在已下架中查看')
            this.getDetail()
            this.onClose()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    onAdd () {
      this.isNoticeClassify = true
    },
    onCloseNotice () {
      this.isNoticeClassify = false
      this.noticeName = ''
    },
    submitNotice () {
      if (!this.noticeName) {
        this.$message.warning('请输入公告分类名称')
      } else {
        let params = {
          name: this.noticeName,
          companyId: this.$store.state.companyId
        }
        this.axios.post('noticeClassify/save', params).then(res => {
          if (res.data.success) {
            this.$message.success('添加公告分类成功')
            this.isNoticeClassify = false
            this.noticeName = ''
            this.getClassify()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    httpRequestImg (e) {
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 3)
      formData.append('description', '')
      let that = this
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        that.fileList = onloadRes.data.data.path
        if (e.filename === 'modifyfile') {
          that.modifyNotice(e.data.id, that.fileList)
        }
      }).catch(() => {
        this.$message.error('上传失败！')
      })
    },
    getEnclosureTypeImg (path) {
      if (path) {
        let type = path.substring(path.lastIndexOf('.') + 1)
        switch (type.toLowerCase()) {
          case 'doc':
          case 'docx':
            return '/static/images/word.png'
          case 'pdf':
            return '/static/images/pdf.png'
          case 'ppt':
            return '/static/images/ppt.png'
          case 'xls':
          case 'xlsx':
            return '/static/images/excel.png'
          case 'dwg':
            return '/static/images/cad.png'
          case 'txt':
            return '/static/images/txt.png'
          default:
            return '/static/images/other.png'
        }
      }
    },
    removeEnclosure () {
      this.$confirm('点击保存之后才能真正删除该附件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fileList = ''
        this.$message({
          type: 'success',
          message: '删除成功'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getDetail()
    }
  }
}
</script>

<style lang="scss" scoped>
.enclosure-container {
  max-height: 300px;

  .enclosure-item {
    width: 70px;
    height: 70px;
    background-color: #f3f4f7;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 5px 0;

    .type-img {
      width: 38px;
      height: 42px;
    }

    i {
      width: 14px;
      height: 14px;
      color: #ff5555;
      cursor: pointer;
      position: absolute;
      top: 2px;
      right: 2px;
    }
  }
}

.left-top {
  display: flex;
  align-items: center;
  padding: 0 10px 0 20px;
  border-bottom: 1px solid #e2e2e2;
  height: 40px;
  text-align: left;
  cursor: pointer;
}

.content-top {
  height: 30px;

  .tab-item {
    font-size: 16px;
    color: #272727;
    display: flex;
    align-items: center;
    margin-right: 15px;
    cursor: pointer;

    span {
      height: 16px;
    }

    &.active {
      color: #46b8b0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/administrative/announcement.vue